module.exports = __webpack_public_path__ + "static/jim-78bdc1e1718c6af09f1d0c06393afb5a.png";